module.exports = __webpack_public_path__ + "img/ic_visa_embassy.55b135d4.png";